/**
 * Central fetch: optional timeout, propagates user AbortSignal, sets X-Request-ID for
 * CEX/DEX request correlation with backend `X-Request-ID` middleware.
 */
function requestId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `req-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

/**
 * @param {RequestInfo | URL} input
 * @param {RequestInit & { timeoutMs?: number }} [init]
 * @returns {Promise<Response>}
 */
export async function apiFetch(input, init = {}) {
  const { timeoutMs = 30_000, ...rest } = init
  const ac = new AbortController()
  const t = setTimeout(() => ac.abort(), timeoutMs)
  const userSignal = rest.signal
  if (userSignal) {
    if (userSignal.aborted) {
      clearTimeout(t)
      throw new DOMException('Aborted', 'AbortError')
    }
    userSignal.addEventListener('abort', () => {
      clearTimeout(t)
      ac.abort()
    }, { once: true })
  }
  const headers = new Headers(rest.headers)
  if (!headers.has('X-Request-ID')) {
    headers.set('X-Request-ID', requestId())
  }
  try {
    return await fetch(input, { ...rest, signal: ac.signal, headers })
  } finally {
    clearTimeout(t)
  }
}
